import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useApolloClient } from '@apollo/client'

import {
    BayphoneSelectedActions,
} from '../../components/BPMTable/TableMapperCreator'
import { 
    ExportFooterItemCreator,
    MassiveUploadFooterItemCreator,
 } from '../../components/BPMTable/TableFooterItems'

import BPMTable from '../../components/BPMTable/BPMTable'

import tableCreatorCreatorFactoryCreator from '../../components/BPMTable/TableCreatorFactory/TableCreatorCreatorFactoryCreator'
import formCreatorCreatorFactoryCreator from '../../components/BPMTable/FormCreatorFactory/FormCreatorCreatorFactoryCreator'
import BayphoneTableCreator from '../../tableDefinitions/Bayphone/BayphoneTableCreator'
import BayphoneFormCreator from '../../tableDefinitions/Bayphone/BayphoneFormCreator'
import BayphonePopupContent from './BayphonePopupContent'
import { PopUpRowActionButtonCreator } from '../../components/BPMTable/TableComponents/CellComponents/PopupCellComponent'
import HistoryIcon from '@material-ui/icons/History'

import BayphoneCloseDialog from './BayphoneDialogs/BayphoneCloseDialog'
import BayphoneActivateDialog from './BayphoneDialogs/BayphoneActivateDialog'
import BayphoneResendMailDialog from './BayphoneDialogs/BayphoneResendMailDialog'
import BayphoneReimbursedDialog from './BayphoneDialogs/BayphoneReimbursedDialog'
import BayphoneHoldDialog from './BayphoneDialogs/BayphoneHoldDialog'
import BayphoneUnHoldDialog from './BayphoneDialogs/BayphoneUnHoldDialog'


const Bayphone = (props) => {
    const { t } = useTranslation(['bayphone'])
    const client = useApolloClient()

    const [openActivateDialog, setOpenActivateDialog] = useState(false)
    const [openResendMailDialog, setOpenResendMailDialog] = useState(false)
    const [openReimbursedDialog, setOpenReimbursedDialog] = useState(false)
    const [openHoldDialog, setOpenHoldDialog] = useState(false)
    const [openUnHoldDialog, setOpenUnHoldDialog] = useState(false)
    const [openCloseDialog, setOpenCloseDialog] = useState(false)

    document.title = `${t('Bayphone')} - BubbleBPM`

    const path = props.match.url

    const handleOpenActivateDialog = () => {
        setOpenActivateDialog(true)
    }

    const activateDialog = {
        dialog: BayphoneActivateDialog, 
        openDialogState: () => {
            return openActivateDialog
        }, 
        closeDialogAction: () => {
            setOpenActivateDialog(false)
        },
        dialogAction: () => {},
    }

    const handleOpenResendMailDialog = () => {
        setOpenResendMailDialog(true)
    }

    const resendMailDialog = {
        dialog: BayphoneResendMailDialog, 
        openDialogState: () => {
            return openResendMailDialog
        }, 
        closeDialogAction: () => {
            setOpenResendMailDialog(false)
        },
        dialogAction: () => {},
    }

    const handleOpenReimbursedDialog = () => {
        setOpenReimbursedDialog(true)
    }

    const reimbursedDialog = {
        dialog: BayphoneReimbursedDialog, 
        openDialogState: () => {
            return openReimbursedDialog
        }, 
        closeDialogAction: () => {
            setOpenReimbursedDialog(false)
        },
        dialogAction: () => {},
    }

    const handleOpenHoldDialog = () => {
        setOpenHoldDialog(true)
    }

    const holdDialog = {
        dialog: BayphoneHoldDialog, 
        openDialogState: () => {
            return openHoldDialog
        }, 
        closeDialogAction: () => {
            setOpenHoldDialog(false)
        },
        dialogAction: () => {},
    }

    const handleOpenUnHoldDialog = () => {
        setOpenUnHoldDialog(true)
    }

    const unHoldDialog = {
        dialog: BayphoneUnHoldDialog, 
        openDialogState: () => {
            return openUnHoldDialog
        }, 
        closeDialogAction: () => {
            setOpenUnHoldDialog(false)
        },
        dialogAction: () => {},
    }

    const handleOpenCloseDialog = () => {
        setOpenCloseDialog(true)
    }

    const closeDialog = {
        dialog: BayphoneCloseDialog, 
        openDialogState: () => {
            return openCloseDialog
        }, 
        closeDialogAction: () => {
            setOpenCloseDialog(false)
        },
        dialogAction: () => {},
    }

    var tableCreatorCreator = tableCreatorCreatorFactoryCreator.getTableCreatorCreatorFromIdentifier(BayphoneTableCreator.getId(), {tcFilters: {}})
    tableCreatorCreator.setClient(client)

    const tableCreator = tableCreatorCreator.getTableCreator('Bayphones')
    tableCreator.setAdditionalFilters({first:30})
    tableCreator.setInitialSortField('createdAt', 'desc')
    tableCreator.setSelectedRowActionsStrategy(new BayphoneSelectedActions(handleOpenActivateDialog, handleOpenResendMailDialog, handleOpenReimbursedDialog, handleOpenHoldDialog, handleOpenUnHoldDialog, handleOpenCloseDialog))
    tableCreator.setTableFooterItems([new ExportFooterItemCreator(), new MassiveUploadFooterItemCreator()]);

    // La strategy de popup para Bayphone (BayphonePopupContent) estaba comentada porque el click de fila muestra detalle.
    // La adaptamos como acción en la celda usando PopUpComponentCreator para abrir el History popup.
    const BayphoneHistoryIcon = () => (<HistoryIcon />)
    const BayphoneHistoryDialogBody = (props2) => {
        // props2.rowData es el "data" mapeado de la fila; fabricamos la estructura esperada por BayphonePopupContent
        const fakeData = { rawData: { bayphone: { id: props2.rowData.id } } }
        return (
            <BayphonePopupContent data={fakeData} close={props2.handleClose} />
        )
    }
    tableCreator.addRowActionButtonCreator(new PopUpRowActionButtonCreator(BayphoneHistoryIcon, BayphoneHistoryDialogBody, {}, 'iconButton', 'history'))

    tableCreator.setTableFooterDialogs([activateDialog, resendMailDialog, reimbursedDialog, holdDialog, unHoldDialog, closeDialog])
    tableCreator.setShowPopupChangeHistoryPanel(false);

    var formCreatorCreator = formCreatorCreatorFactoryCreator.getFormCreatorCreatorFromIdentifier(BayphoneFormCreator.getId(), null)
    const formCreator = formCreatorCreator.getFormCreator()

    return (
        <>
            <BPMTable
                TableCreator={tableCreator}
                FormCreator={formCreator}
                path={path}
            />
        </>
    )
}

export default Bayphone
